import { VFC } from "react";
import { css } from "src/styles/theme";
import { examples } from "../playground.constants";
import { Playground } from "./playground";
import * as Tabs from "@radix-ui/react-tabs";

export const ExamplePlayground: VFC = () => {
  return (
    <Tabs.Root defaultValue={examples[0].key} asChild>
      <div className={$examplePlayground()}>
        <Tabs.List className={$tabList()}>
          {examples.map(({ key, name }) => (
            <Tabs.Trigger key={key} value={key} className={$tabTrigger()}>
              {name}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {examples.map(({ key, stateBuilder }) => (
          <Tabs.Content value={key} key={key} asChild>
            <Playground initialState={stateBuilder} />
          </Tabs.Content>
        ))}
      </div>
    </Tabs.Root>
  );
};

const $examplePlayground = css({
  height: "auto",
  display: "flex",
  flexDirection: "column",
  boxShadow: "$2, $5",
  borderRadius: "$3",
  border: "1px solid $neutral2",
  backgroundColor: "$background",
  overflow: "hidden",

  "@medium": {
    height: "40rem",
  },
});

const $tabList = css({
  boxShadow: "$2",
  padding: "$2",
  zIndex: 1,
  overflowX: "auto",
  overflowY: "hidden",
  textAlign: "center",
  flexShrink: 0,
});

const $tabTrigger = css({
  applyReset: "btn",
  padding: "$2 $4",
  borderRadius: "$full",
  color: "$primaryText",
  fontSize: "$sm",

  '&[data-state="active"]': {
    backgroundColor: "$primaryBg",
  },
});
